<template lang="pug">
#aba-area-monitorada
    .aba-header
        h3 Área monitorada {{ idAreaMonitorada() }}

        .back(@click='goToInicio()')
            i.mdi.mdi-arrow-left
            h5 Voltar

    .aba-body
        dados-area-monitorada(:areaMonitorada='data')

        dados-monitoramento(
            v-show='abaSelecionadaAreaMonitorada === \'monitoramento\'',
            :areaMonitorada='data'
        )
</template>

<script>
import DadosAreaMonitorada from './DadosAreaMonitorada';
import DadosMonitoramento from './DadosMonitoramento';
import { mapGetters } from 'vuex';

export default {
    name: 'AbaAreaMonitorada',

    components: { DadosMonitoramento, DadosAreaMonitorada },

    props: {
        data: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters(['abaSelecionadaAreaMonitorada'])
    },

    methods: {
        goToInicio() {
            this.$router.push({ name: 'Inicio' });
        },

        idAreaMonitorada() {
            return this.$route.params.idAreaMonitorada;
        }

        // openModal () {
        // 	this.$emit('open-modal');
        // }
    }
};
</script>

<style scoped lang="scss">
#aba-area-monitorada {
    height: 100%;
    overflow: auto;
    background-color: var(--white);
    margin-left: 55px;
    @include box-shadow(3px, 0, 6px, rgba(0, 0, 0, 0.04));

    .aba-body {
        // margin-top: 70px;
        // position: fixed;
        overflow: auto;
        // height: calc(100vh - $header-height);
        height: calc(100vh - 70px);
        width: 100%;
        background-color: var(--white);
        @include scroll-bar();
    }

    .aba-header {
        display: flex;
        min-width: 340px;
        // position: fixed;
        background-color: var(--white);
        width: 100%;
        justify-content: space-between;
        // z-index: 1030;
        border-bottom: solid 1px var(--default-border-color);
        height: 70px;
        align-items: center;
        padding: 0 20px;
        @include box-shadow(3px, 0, 6px, rgba(0, 0, 0, 0.04));

        h3 {
            font-weight: map-get($font-weight, medium);
        }

        .back {
            align-items: center;
            display: flex;
            color: var(--primary);
            cursor: pointer;

            h5 {
                margin-left: 3px;
            }
        }
    }
}
</style>
